"use strict";
exports.__esModule = true;
exports.getInitialFileUploadData = void 0;
var constants_1 = require("../constants");
var IS_CUSTOM_BUCKET_ENABLED = constants_1.INPUT_BLOCK_KEYS.IS_CUSTOM_BUCKET_ENABLED, CUSTOM_S3_BUCKET_DETAILS = constants_1.INPUT_BLOCK_KEYS.CUSTOM_S3_BUCKET_DETAILS, S3_BUCKET_NAME = constants_1.INPUT_BLOCK_KEYS.S3_BUCKET_NAME, BUCKET_ARN = constants_1.INPUT_BLOCK_KEYS.BUCKET_ARN, BUCKET_REGION = constants_1.INPUT_BLOCK_KEYS.BUCKET_REGION, EXPIRY = constants_1.INPUT_BLOCK_KEYS.EXPIRY, OBJECT_ACL = constants_1.INPUT_BLOCK_KEYS.OBJECT_ACL, DIRECTORY = constants_1.INPUT_BLOCK_KEYS.DIRECTORY;
var getInitialFileUploadData = function (value) {
    var _a, _b;
    return (_a = {},
        _a[IS_CUSTOM_BUCKET_ENABLED] = value,
        _a[CUSTOM_S3_BUCKET_DETAILS] = (_b = {},
            _b[BUCKET_ARN] = '',
            _b[S3_BUCKET_NAME] = '',
            _b[BUCKET_REGION] = '',
            _b[EXPIRY] = value ? undefined : 0,
            _b[OBJECT_ACL] = '',
            _b[DIRECTORY] = '',
            _b),
        _a);
};
exports.getInitialFileUploadData = getInitialFileUploadData;
